module.exports = __webpack_public_path__ + "img/grgwjkxtmix.67f80b06.jpg";